// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2434":"25a97365","4363":"f537670f","5608":"0b12ae6c","6832":"f537670f","8491":"2070c431"}[chunkId] + ".chunk.css";
};